import { ReportMetric } from '@/renderer/types';
import { getReportMetricToneClasses } from '@/renderer/util/reporting';
import React from 'react';

export const SummaryMetricCard: React.FC<ReportMetric> = ({
  label,
  value,
  hint,
  tone,
}) => (
  <div className={`rounded-2xl border p-4 ${getReportMetricToneClasses(tone)}`}>
    <p className="text-[11px] font-semibold uppercase tracking-[0.24em]">
      {label}
    </p>
    <p className="mt-3 text-2xl font-semibold text-slate-900">{value}</p>
    {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
  </div>
);
